import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FlowNode } from '@features/flow-ui-creator/interfaces/flow-ui.interface';
import {
  NodeData,
  NodeEditorCondition,
  NodeEditorDtoMapping,
  NodeEditorLoopParameter,
  NodeType,
} from '@features/flow-ui-creator/interfaces/node.interface';
import { NodeBackgroundColorPipe } from '@features/flow-ui-creator/pipes/node-background-color.pipe';
import { NodeIconPipe } from '@features/flow-ui-creator/pipes/node-icon.pipe';
import { NodeWarningTooltipPipe } from '@features/flow-ui-creator/pipes/node-warning-tooltip.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ReteModule } from 'rete-angular-plugin/21';
import { BaseNodeComponent } from '../base-node/base-node.component';
import { NodeSocketComponent } from '../node-socket/node-socket.component';

@Component({
  selector: 'app-condition-node',
  imports: [
    CommonModule,
    ReteModule,
    NodeBackgroundColorPipe,
    NodeSocketComponent,
    TooltipModule,
    TranslateModule,
    NodeIconPipe,
    NodeWarningTooltipPipe,
  ],
  templateUrl: './condition-node.component.html',
  styleUrls: ['./condition-node.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    'data-testid': 'node',
  },
})
export class ConditionNodeComponent extends BaseNodeComponent<
  FlowNode<NodeData<(NodeEditorCondition | NodeEditorDtoMapping | NodeEditorLoopParameter)[]>>
> {
  noTitleLabelNodeTypes = [NodeType.Gateway, NodeType.Notify, NodeType.HttpResponse];
}
